import { useEffect } from 'react';
import { loadMavenScript, MavenConfig, MavenUiConfig } from '@clio/maven-chat';
import { useMavenIntegrationEnabled } from '~/src/entities/user/hooks/useFeatureAccess';
import { useCurrentOrgFprint } from '~/src/entities/user/hooks/useCurrentOrg';
import mavenService from '~/src/services/api/mavenService';
import env from '~/src/utils/env';

const uiConfig: MavenUiConfig = {
  buttonCorner: 'right bottom',
  buttonPosition: {
    bottom: '70px',
    right: '20px',
  },
  chatWindowPosition: {
    bottom: '100px',
    right: '50px',
  },
};

export const MavenChat = () => {
  const isMavenEnabled = useMavenIntegrationEnabled();
  const orgFprint = useCurrentOrgFprint();

  useEffect(() => {
    if (!isMavenEnabled || !orgFprint) return;
    const baseConfig: MavenConfig = { tags: ['draft'] };
    if (env.reactAppEnvironment === 'staging') {
      baseConfig.agentId = 'cliostaging';
    }

    const initializeMavenChat = async (): Promise<void> => {
      try {
        const getSignedUserData = async (): Promise<MavenConfig> => {
          try {
            const { signedUserData } = await mavenService.getMavenJWT(
              orgFprint,
            );
            return { ...baseConfig, signedUserData };
          } catch (error) {
            console.error('Failed to get Maven JWT:', error);
            return baseConfig;
          }
        };

        await loadMavenScript(getSignedUserData, uiConfig);
      } catch (error) {
        console.error('Failed to initialize Maven chat:', error);
      }
    };

    initializeMavenChat();
  }, [isMavenEnabled, orgFprint]);

  return null;
};
